import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import Watermark from './utils/wartermark'
Vue.use(preview)
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(MintUI)
const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : ''
console.log(user)
new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    Watermark.set(user.typeName + user.name)
  }
}).$mount('#app')
